import { FormTemplateStateEnum } from '@/models/form-template';
import {
  EmployeeFormSubmission,
  EmployeeFormSubmissionComment
} from '../employee-form';
import {
  IEmployeeFormSubmission,
  IEmployeeFormSubmissionComment,
  IEmployeeFormSubmissionCommentData,
  IEmployeeFormSubmissionData
} from '../employee-form.types';

export const mockEmployeeFormSubmissionCommentsData = (): IEmployeeFormSubmissionCommentData[] => [
  {
    id: 17,
    owner: 'Lamar Falconer',
    text:
      '<p>test data @uid:39  @uid:3  @uid:51 @uid:39 </p><p><br></p><p>test data @uid:39 </p><p><br></p><p>over here</p>',
    created_at: '2023-11-01T18:19:39.729729Z',
    updated_at: '2023-11-01T20:48:35.177459Z',
    mentions: [
      {
        id: 3,
        first_name: 'Brandon',
        last_name: 'Puim',
        email: 'bpuim@altoleap.com',
        employee: {
          id: 157,
          first_name: 'Brandon',
          last_name: 'Puim',
          type: 1,
          title: ''
        }
      },
      {
        id: 51,
        first_name: 'Nelson',
        last_name: 'Alba',
        email: 'Nelson.Alba@jcmincubator.com',
        employee: {
          id: 189,
          first_name: 'Nelson',
          last_name: 'Alba',
          type: 1,
          title: ''
        }
      },
      {
        id: 39,
        first_name: 'Pragnya',
        last_name: 'Mandala',
        email: 'pragnya.mandala@jcmincubator.com',
        employee: {
          id: 146,
          first_name: 'Pragnya',
          last_name: 'Mandala',
          type: 1,
          title: 'Business Analyst'
        }
      }
    ]
  },

  {
    id: 8,
    owner: 'Lamar Falconer',
    text: '<p>test @uid:3 </p>',
    created_at: '2023-11-01T17:15:10.912613Z',
    updated_at: '2023-11-01T17:15:10.912613Z',
    mentions: [
      {
        id: 3,
        first_name: 'Brandon',
        last_name: 'Puim',
        email: 'bpuim@altoleap.com',
        employee: {
          id: 157,
          first_name: 'Brandon',
          last_name: 'Puim',
          type: 1,
          title: ''
        }
      }
    ]
  }
];

export const mockEmployeeFormSubmissionsData = (): IEmployeeFormSubmissionData[] => [
  {
    id: 1,
    form: {
      id: 1,
      title: 'Employee Onboarding',
      description: 'this is for employee onboarding',
      state: FormTemplateStateEnum.Draft
    },
    state: 0,
    answers: [
      {
        id: 1,
        value: 'MNadi',
        field: 2,
        option_submissions: []
      },
      {
        id: 2,
        value: 'grant',
        field: 4,
        option_submissions: []
      }
    ],
    created_at: '2023-03-17T19:54:36.647766Z',
    updated_at: '2023-03-17T19:54:36.647827Z'
  }
];

export const mockEmployeeFormSubmissions = (
  data: IEmployeeFormSubmissionData[] = mockEmployeeFormSubmissionsData()
): IEmployeeFormSubmission[] =>
  data.map(item => new EmployeeFormSubmission(item));

export const mockEmployeeFormSubmissionComments = (
  data: IEmployeeFormSubmissionCommentData[] = mockEmployeeFormSubmissionCommentsData()
): IEmployeeFormSubmissionComment[] =>
  data.map(comment => new EmployeeFormSubmissionComment(comment));
